var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0469 38.5938L36.4062 21.9531L53.0469 5.3125L69.6875 21.9531L53.0469 38.5938ZM9.375 32.9688V9.45313H32.8906V32.9688H9.375ZM42.0312 65.625V42.1094H65.5469V65.625H42.0312ZM9.375 65.625V42.1094H32.8906V65.625H9.375ZM14.0625 28.2813H28.2031V14.1406H14.0625V28.2813ZM53.2812 32.2656L63.3594 22.1875L53.2812 12.1094L43.2031 22.1875L53.2812 32.2656ZM46.7187 60.9375H60.8594V46.7969H46.7187V60.9375ZM14.0625 60.9375H28.2031V46.7969H14.0625V60.9375Z",
    fill: "#4F3318"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlign);
export default __webpack_public_path__ + "static/media/align.be3459fc815dd4d2a9d108f72063133e.svg";
export { ForwardRef as ReactComponent };